module.exports = __webpack_public_path__ + "static/img/scene3.974fa0f0.png";